import React from 'react';
import T from 'prop-types';
import { Alert } from 'antd';

const ErrorAlert = ({ visible, message, ...props }) => {
  if (!visible) {
    return null;
  }

  return <Alert message={message} type="error" {...props} />;
};

ErrorAlert.propTypes = {
  visible: T.bool.isRequired,
  message: T.string.isRequired,
};

export default ErrorAlert;
